  document.addEventListener('DOMContentLoaded', () => {
    // ==========================
    // SORT BY
    // ==========================
    const sortSelect = document.getElementById('SortBy');

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href);

        url.searchParams.set('sort_by', this.value);

        window.location.assign(url.toString());
      });
    }

    // ==========================
    // COLLECTION PILLS
    // ==========================
    document.querySelectorAll('[data-collection-url]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const url = new URL(link.dataset.collectionUrl, window.location.origin);

        const currentParams = new URLSearchParams(window.location.search);

        currentParams.forEach((value, key) => {
          url.searchParams.append(key, value);
        });

        window.location.assign(url.toString());
      });
    });
  });